module.exports = __webpack_public_path__ + "img/credit-card-all.74defe04.png";